/**
 * Created by fers on 29.07.16.
 */
import React from 'react';
import PropTypes from 'prop-types';
import config from '../../common/config';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import EntityDefIcon from './EntityDefIcon.react';

import './ChannelIcon.scss';
import { ChannelDef } from '../../common/types/types';

interface ChannelIconProps {
    channelDef: ChannelDef;
    className?: string;
    noDimensions?: boolean;
    size: number;
}

export default class ChannelIcon extends React.Component<ChannelIconProps> {
    static propTypes = {
		channelDef: PropTypes.object.isRequired,
		className: PropTypes.string,
		noDimensions: PropTypes.bool,
        size: PropTypes.number.isRequired,
    };

    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    renderBaseIcon(icon, size, extraClassName, altOverride) {
        if (!icon) {
            return (<div></div>);
        }

        if (icon.startsWith("fa-")) {
            return (
                <div style={{color: 'grey', 'fontSize': '1.2em', 'textAlign': 'center'}}>
                    <EntityDefIcon icon={icon} />
                </div>
            );
        }

        return (
            <img
                alt={altOverride !== undefined ? altOverride : this.props.channelDef.name}
                className={icon + " " + (this.props.noDimensions ? null : "dativery-icon-" + size) + " " + (extraClassName || "")}
                height={this.props.noDimensions ? null : size}
                src={config.PUBLIC_CDN + "/logos/channels/resized/" + icon + "-" + (size * 2) + ".png"}
                title={this.props.channelDef.name}
                width={this.props.noDimensions ? null : size}
            />
        );
    }

    render() {
		let icon = this.props.channelDef.icon;
        const parentIcon =
            this.props.channelDef &&
            this.props.channelDef.extendedFrom &&
            this.props.channelDef.extendedFrom.icon
                ? this.props.channelDef.extendedFrom.icon
                : null;
		const hasExtendedFromId = Boolean(this.props.channelDef && this.props.channelDef.extendedFrom_id);

        if (!icon) {
            return (<div></div>);
        }

        // Use only "known good" sizes so the CDN logo file exists.
        // (Arbitrary sizes like 19 -> 38px often don't exist and then the browser shows alt text.)
        // Then adjust visually via CSS scale for small icons (flow icons ~54px).
        const badgeSize =
            this.props.size >= 96
                ? 32
                : (this.props.size >= 64 ? 24 : (this.props.size >= 48 ? 16 : null));
        const showParentBadge = Boolean(parentIcon && parentIcon !== icon && !this.props.noDimensions);

        return (
            <span className="channelIconWrapper">
                {this.renderBaseIcon(icon, this.props.size, this.props.className || "")}
                {showParentBadge && badgeSize ? (
                    <span
                        className={
                            "channelIconExtendedFromBadge " +
                            (this.props.size < 64 ? "channelIconExtendedFromBadge--small" : "channelIconExtendedFromBadge--large")
                        }
                        title="Extended from"
                    >
                        {this.renderBaseIcon(parentIcon, badgeSize, "channelIconExtendedFromBadgeImg", "")}
                    </span>
                ) : null}
            </span>
        );
    }
}
